import customForm from './modules/custom-form';
import { registerScriptDependencies } from './modules/dynamic-scripts';
import './modules/section';
import './modules/video';

document.addEventListener('DOMContentLoaded', registerScriptDependencies);

customForm();
